<div class="cell auto cell-block-y animatorClosure">
    <div class="animatorClosure-header">
        <h2 class="animatorClosure-header-title"><span [i18nKey]="'animator.decisions.closure.title'"></span>
            <p class="period-info">
                <kiwi-period [period]="period"></kiwi-period>
            </p>
        </h2>
        <button class="button generaleClosureBtn" (click)="closeAllDecisions()">
            <i class="fas fa-lock generaleClosureBtn-icon"></i><span [i18nKey]="'animator.decisions.closure.general.closure'"></span></button>
        <div class="animatorClosure-header-illu"></div>
    </div>

    <div class="animatorClosure-content" *ngIf="!!teamsDecisions">
        <div class="animatorClosure-content-item"
             *ngFor="let team of teams"
             [class.closed]="teamsDecisions[team.teamNumber].statusData.currentStatus === 'CLOSED'">
            <h4 class="teamClose">{{team.teamNumber}} - {{team.name}}</h4>
            <div class="animatorClosure-content-item-closure">
                <div class="player-closure">
                    <h6 class="title-closure-part"[i18nKey]="'animator.decisions.closure.team.closure'"></h6>
                    <p *ngIf="teamsDecisions[team.teamNumber].statusData.teamClosureLog; else noTeamClosure">
                        <span [i18nKey]="'animator.decisions.closure.closed'"></span>
                        {{(teamsDecisions[team.teamNumber].statusData.teamClosureLog.date | date:'short':'':'fr-FR') ||
                        ('common.no.value' |
                        translate)}}
                        <br> <span [i18nKey]="'common.by'"></span>
                        <b>{{teamsDecisions[team.teamNumber].statusData.teamClosureLog.firstName}}
                            {{teamsDecisions[team.teamNumber].statusData.teamClosureLog.lastName}}</b>

                        <button (click)="openDecision(team.teamNumber, 'IN_PROGRESS')" class="button _tiny _cancel"[i18nKey]="'animator.decisions.closure.closure.cancel'"></button>
                    </p>
                    <ng-template #noTeamClosure [i18nKey]="'animator.decisions.closure.no.team.closure'"></ng-template>
                </div>
                <div class="animator-closure">
                    <h6 class="title-closure-part"[i18nKey]="'animator.decisions.closure.animator.closure'"></h6>
                    <div *ngIf="teamsDecisions[team.teamNumber].statusData.animatorClosureLog; else noAnimatorClosure">
                        <p>
                            <span [i18nKey]="'animator.decisions.closure.closed'"></span>
                            {{(teamsDecisions[team.teamNumber].statusData.animatorClosureLog.date | date:'short':'':'fr-FR')
                        || ('common.no.value' |
                            translate)}}
                            <br> <span [i18nKey]="'common.by'"></span>
                            <b>{{teamsDecisions[team.teamNumber].statusData.animatorClosureLog.firstName}}
                                {{teamsDecisions[team.teamNumber].statusData.animatorClosureLog.lastName}}</b>
                        </p>
                        <button (click)="openDecision(team.teamNumber, 'ANIMATOR_ONLY')" class="button _tiny _cancel"[i18nKey]="'animator.decisions.closure.closure.cancel'"></button>
                    </div>
                    <ng-template #noAnimatorClosure>
                        <span [i18nKey]="'animator.decisions.closure.no.animator.closure'"></span>
                        <button (click)="closeDecision(team.teamNumber)" class="button _tiny _primaryDark forceClosureBtn" *ngIf="teamsDecisions[team.teamNumber].statusData.teamClosureLog"[i18nKey]="'animator.decisions.closure.animator.closure'"></button>
                    </ng-template>
                </div>
            </div>
            <button *ngIf="teamsDecisions[team.teamNumber].statusData.currentStatus === 'OPENED'"
                    (click)="closeDecision(team.teamNumber)" class="button _tiny _primaryDark forceClosureBtn"[i18nKey]="'animator.decisions.closure.force.closure'"></button>
        </div>
    </div>
</div>
